import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "image", "caption", "spinner"]
  static values = { photos: Array }

  connect() {
    this.currentIndex = 0
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.lightboxIndex || "0", 10)
    this.show(index)
  }

  show(index) {
    if (!this.photosValue.length) return
    this.currentIndex = index
    const photo = this.photosValue[index]

    this.imageTarget.classList.add("loading")
    this.imageTarget.src = ""
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("visible")

    const img = new Image()
    img.onload = () => {
      this.imageTarget.src = photo.url
      this.imageTarget.classList.remove("loading")
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("visible")
    }
    img.src = photo.url

    this.captionTarget.textContent = photo.label
      ? `${photo.label} — ${index + 1} of ${this.photosValue.length}`
      : `${index + 1} of ${this.photosValue.length}`
    this.overlayTarget.classList.add("open")
    document.addEventListener("keydown", this.handleKeydown)
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.remove("open")
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.style.overflow = ""
  }

  next(event) {
    event?.stopPropagation()
    this.show((this.currentIndex + 1) % this.photosValue.length)
  }

  prev(event) {
    event?.stopPropagation()
    this.show((this.currentIndex - 1 + this.photosValue.length) % this.photosValue.length)
  }

  closeOnBackground(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
    if (event.key === "ArrowRight") this.next()
    if (event.key === "ArrowLeft") this.prev()
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.style.overflow = ""
  }
}
